module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-bg"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "code",
    on: {
      "click": _vm.openBeian
    }
  }, [_vm._v("浙ICP备17049714号-2")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c393e2b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/layout.vue
// module id = 868
// module chunks = 1